// extracted by mini-css-extract-plugin
export default {"wrapper":"ArticlesView_wrapper__sRKKf"};